<template>
  <div class="column-box-container">
    <div
      v-for="mainColumn in this.columns"
      :key="mainColumn.columnId"
      class="column-item-wrapper"
      :class="{ 'is-active': currentActive === mainColumn.columnId }"
      @mouseover="unfoldMainColumn(mainColumn.columnId)"
      @mouseout="foldMainColumn"
      @click="gotoMainColumn(mainColumn)"
    >
      <span v-html="mainColumn.name"></span>
      <div
        v-if="mainColumn.hasSubColumn && mainColumn.normalSubColumns && mainColumn.normalSubColumns.length > 0"
        class="sub-column-wrapper"
        :class="{ hidden: unfoldMainColumnId !== mainColumn.columnId }"
      >
        <div
          v-for="subColumn in mainColumn.normalSubColumns"
          :key="subColumn.columnId"
          class="sub-column-item"
          @click.stop="gotoSubColumn(subColumn)"
        >{{subColumn.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  INDEX_CONTENT_SELF, TYPE_UNDEFINED, TYPE_INTEGRAL, TYPE_NEWS_LIST, TYPE_PERSON_LIST, TYPE_CUSTOMIZED, TYPE_ARTICLE_LIST,
  getAllColumns, getMainColumnContentType, getSubColumnContentType
} from '@/api/column'
import { Message } from 'element-ui'

const MAIN_PAGE_MAIN_COLUMN_ID = 0
const COOPERATION_MAIN_COLUMN_ID = 5
const COOPERATION_SUB_COLUMN_ID = -1
const CONTACT_US_MAIN_COLUMN_ID = -1
const DONATION_LOG_MAIN_COLUMN_ID = 6

export const NEWS_MAIN_COLUMN_ID = 2
export const NEWS_LIST_CONTENT_ID = 1
export const EXPERT_MAIN_COLUMN_ID = 1

export default {
  name: 'ColumnBox',
  data () {
    return {
      columns: [{
        columnId: MAIN_PAGE_MAIN_COLUMN_ID,
        hasSubColumn: false,
        indexContent: 'main',
        name: '首&nbsp;&nbsp;&nbsp;&nbsp;页'
      }],
      currentActive: MAIN_PAGE_MAIN_COLUMN_ID,
      unfoldMainColumnId: -1
    }
  },
  watch: {
    $route () {
      this.currentActive = parseInt(this.$route.params.columnId) || MAIN_PAGE_MAIN_COLUMN_ID
    }
  },
  created () {
    this.currentActive = parseInt(this.$route.params.columnId) || MAIN_PAGE_MAIN_COLUMN_ID
    getAllColumns().then(res => {
      res.data.columns.forEach(column => {
        if (column.columnId === COOPERATION_MAIN_COLUMN_ID) {
          column.normalSubColumns = column.normalSubColumns || []
          column.normalSubColumns.unshift({
            columnId: COOPERATION_SUB_COLUMN_ID,
            parentId: COOPERATION_MAIN_COLUMN_ID,
            name: '合作申请'
          })
        } else if (column.columnId === DONATION_LOG_MAIN_COLUMN_ID) {
          return
        }
        this.columns.push(column)
      })
      this.columns.push({
        columnId: CONTACT_US_MAIN_COLUMN_ID,
        hasSubColumn: false,
        indexContent: INDEX_CONTENT_SELF,
        name: '联系我们'
      })
      this.$store.commit('SET_COLUMNS', this.columns)
    })
  },
  methods: {
    unfoldMainColumn (mainColumnId) {
      if (this.unfoldMainColumnId !== mainColumnId) {
        this.unfoldMainColumnId = mainColumnId
      }
    },
    foldMainColumn () {
      if (this.unfoldMainColumnId !== -1) {
        this.unfoldMainColumnId = -1
      }
    },
    gotoMainColumn (mainColumn) {
      let mainColumnId = mainColumn.columnId
      this.currentActive = mainColumnId
      if (this.currentActive === MAIN_PAGE_MAIN_COLUMN_ID) {
        this.$router.push({ name: 'mainPage' })
      } else if (this.currentActive === CONTACT_US_MAIN_COLUMN_ID) {
        this.$router.push({ name: 'contactUs', params: { columnId: CONTACT_US_MAIN_COLUMN_ID } })
      } else if (this.currentActive === DONATION_LOG_MAIN_COLUMN_ID) {
        this.$router.push({ name: 'donationLog', params: { columnId: DONATION_LOG_MAIN_COLUMN_ID } })
      } else {
        if (mainColumn.indexContent === INDEX_CONTENT_SELF) {
          getMainColumnContentType(mainColumnId).then(res => {
            this.showColumnContent(res.data.content)
          }).catch(_ => {
            this.showErrorMsg()
          })
        } else if (mainColumn.hasSubColumn && mainColumn.normalSubColumns && mainColumn.normalSubColumns.length > 0) {
          this.gotoSubColumn(mainColumn.normalSubColumns[0])
        } else {
          this.showErrorMsg()
        }
      }
    },
    gotoSubColumn (subColumn) {
      let currentSubColumnId = this.$route.params.subColumnId || 0
      if (this.currentActive === subColumn.parentId && currentSubColumnId === subColumn.columnId) {
        return
      } else {
        this.currentActive = subColumn.parentId
      }

      if (this.currentActive === COOPERATION_MAIN_COLUMN_ID && subColumn.columnId === COOPERATION_SUB_COLUMN_ID) {
        this.$router.push({
          name: 'applyCooperation',
          params: { columnId: COOPERATION_MAIN_COLUMN_ID }
        })
        return
      }

      getSubColumnContentType(subColumn.parentId, subColumn.columnId).then(res => {
        this.showColumnContent(res.data.content)
      }).catch(_ => {
        this.showErrorMsg()
      })
    },
    showErrorMsg () {
      Message({
        message: '抱歉，服务器似乎忙不过来啦。',
        type: 'error'
      })
    },
    showColumnContent (content) {
      switch (content.type) {
        case TYPE_UNDEFINED:
        case TYPE_CUSTOMIZED:
          Message({
            message: '栏目维护中，请稍后再试',
            type: 'warning'
          })
          return

        case TYPE_INTEGRAL:
          this.$router.push({
            name: 'integral',
            params: {
              columnId: this.currentActive,
              subColumnId: content.subColumnId || null,
              contentId: content.contentId
            }
          })
          return

        case TYPE_NEWS_LIST:
          this.$router.push({
            name: 'newsList',
            params: {
              columnId: this.currentActive,
              subColumnId: content.subColumnId || null,
              listContentId: content.contentId
            }
          })
          return

        case TYPE_PERSON_LIST:
          this.$router.push({
            name: 'personList',
            params: {
              columnId: this.currentActive,
              subColumnId: content.subColumnId || null,
              listContentId: content.contentId
            }
          })
          return

        case TYPE_ARTICLE_LIST:
          this.$router.push({
            name: 'articleList',
            params: {
              columnId: this.currentActive,
              subColumnId: content.subColumnId || null,
              listContentId: content.contentId
            }
          })
          return

        default:
          this.showErrorMsg()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.column-box-container {
  width: 100%;
  height: 0.46rem;
  padding: 0 1.14rem;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #00B7EE;
  .column-item-wrapper {
    min-width: 1.42rem;
    height: 100%;
    display: inline-block;
    color: white;
    font-size: 0.18rem;
    line-height: 0.46rem;
    text-align: center;
    cursor: pointer;
    &.is-active {
      background-color: #0092D6;
    }
    .sub-column-wrapper {
      position: absolute;
      z-index: 111;
      transform: scaleY(1);
      transform-origin: top;
      transition: transform 0.1s;
      color: white;
      background-color: #0092D6;
      box-shadow: 0 0 0.04rem 0 rgba(black, 0.25);
      &.hidden {
        transform: scaleY(0);
      }
      .sub-column-item {
        width: 1.71rem;
        height: 0.42rem;
        box-sizing: border-box;
        padding-left: 0.19rem;
        font-size: 0.14rem;
        font-weight: normal;
        line-height: 0.42rem;
        text-align: left;
        &:hover {
          background-color: #00B7EE;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ColumnBox/index.vue